import React, { Component } from "react";
import _ from 'i18n';
import {Col, Row} from "antd";
import EventDataTableRow from "./EventDataTableRow";
import AppTypeFilter from "../../Filters/EventStats/AppTypeFilter";
import SearchFilter from "../../Filters/EventStats/SearchFilter";
import { Pagination } from 'antd';
import PageSizeFilter from "../../Filters/EventStats/PageSizeFilter";
import {
  setEventStatsPageCurrent
} from "../../../actions/actions/eventStats";
import {connect} from "react-redux";
import {
  fetchCongressesDetails,
  getEventStatsDataTable
} from "../../../actions/thunks/eventStats";
import EventDataTableRowFeetching
  from "../../feetching/EventDataTableRowFeetching";
import LanguageFilter from "../../Filters/EventStats/LanguageFilter";
import NotFoundPage from "../../NotFoundPage";
import ActivitiesOrderFilter
  from "../../Filters/EventStats/ActivitiesOrderFilter";


class EventDataTable extends Component {

  itemRender = (current, type, originalElement) => {
    if (type === 'prev') {
      return <button className={'event-previous-button'}>Previous</button>;
    }
    if (type === 'next') {
      return <button className={'event-next-button'}>Next</button>;
    }
    return originalElement;
  }


  componentDidUpdate(nextProps, nextState, nextContext) {
    if (nextProps.eventStatsFilter !== this.props.eventStatsFilter) {
      this.getEventStatsDataTable();
    }
  }

  componentDidMount() {
    this.getEventStatsDataTable();
  }


  getEventStatsDataTable = () => {
    const {eventStatsFilter} = this.props;

    let params = {};

    if (this.props.eventStatsFilter.search.trim() !== "") {
      params.search = this.props.eventStatsFilter.search;
    }

    if (this.props.eventStatsFilter.year.length > 0) {
      params.year = this.props.eventStatsFilter.year;
    }

    if (this.props.eventStatsFilter.appType.length > 0) {
      params.appType = this.props.eventStatsFilter.appType;
    }

    if(this.props.auth.currentClient) {
      params.issuerId = this.props.auth.currentClient.id;
    }

    params.limit = this.props.eventStatsFilter.pageSize;
    params.start = (this.props.eventStatsFilter.current - 1) * this.props.eventStatsFilter.pageSize;
    params.lang = this.props.eventStatsFilter.language;
    params.startMonth = this.props.eventStatsFilter.startMonth;
    params.endMonth = this.props.eventStatsFilter.endMonth;
    params.season = isNaN(this.props.eventStatsFilter.season) ? this.props.eventStatsFilter.season : Number(this.props.eventStatsFilter.season);
    params.activitiesOrder = this.props.eventStatsFilter.activitiesOrder;

    if(eventStatsFilter.appType != 'congres'){
      this.props.getEventStatsDataTable(params);
    } else {
      this.props.fetchCongressesDetails(params);
    }

  }

  handlePaginationChange = (page, pageSize) => {
    this.props.setEventStatsPageCurrent(page);
  }

  calculateCongressRegistrants = (event) => {
    event.paidRegistrant = 0;
    event.notPaidRegistrant = 0;

    if(event.plan){
      event.plan.forEach(element => {
        event.paidRegistrant += element.payingPersons;
        event.notPaidRegistrant += element.notPayingPersons;
      })

      event.pack.forEach(element => {
        event.paidRegistrant += element.packGuests;
      })
    }
  };

  render() {
    const { appType } = this.props.eventStatsFilter;
    return (
      <div className={'event-datatable'}>
        <div className={'event-stats-section-title'}>{_('ACTIVITIES')}</div>
        <div className={'flex items-center'}>
          <LanguageFilter/>
          <div className={'ml-auto'}>
            <div className={'flex items-center'}>
              <SearchFilter/>
              <PageSizeFilter/>
            </div>
          </div>
        </div>
        <hr className="event-stats-activities-filters-hr"/>
        <div className={'flex'}>
          <AppTypeFilter/>
          <div className={'ml-auto'}>
            <ActivitiesOrderFilter/>
          </div>
        </div>


        {this.props.eventStatsDataTable.items.length === 0 && this.props.eventStatsDataTable.fetched == true ?
          <NotFoundPage/> :
          <div style={{paddingBottom: '20px'}}>
            <Row className="event-stats-title" justify="space-around">
              <Col offset={1} span={3}>{_('Date')}</Col>
              <Col span={7}>{_('TITLE')}</Col>
              <Col offset={1} span={3}>{_('PAID_REGISTRANTS')}</Col>
              <Col offset={1} span={3}>{_('FREE_REGISTRANTS')}</Col>
              <Col offset={1} span={4}>{_('TOTAL')}</Col>
            </Row>
            <br/>
            {
              this.props.eventStatsDataTable.fetching ?
                <EventDataTableRowFeetching/> :
                <div>
                  {
                    this.props.eventStatsDataTable.items.map((x, i) => {
                    if (appType == "congres")
                      this.calculateCongressRegistrants(x);
                    return <EventDataTableRow key={i} event={x}/>
                    })
                  }
                  <Pagination current={this.props.eventStatsFilter.current}
                              total={this.props.eventStatsDataTable.nbResult}
                              onChange={this.handlePaginationChange}
                              itemRender={this.itemRender}
                              pageSize={parseInt(this.props.eventStatsFilter.pageSize)}
                              defaultPageSize={5}
                              className={appType == 'registering' ? 'event-stats-blue-theme' :
                                (appType == 'cycle_registering' ? 'event-stats-purple-theme' :
                                  (appType == 'all_in' ? 'event-stats-orange-theme' : 'event-stats-grey-theme'))}/>
                </div>
            }
          </div>
        }

      </div>
    );
  }
}

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
  eventStatsDataTable: state.eventStatsDataTable,
  auth: state.auth,
});

const mapDispatchToProps = {
  getEventStatsDataTable,
  setEventStatsPageCurrent,
  fetchCongressesDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventDataTable);



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventDataTable.js